import { render, staticRenderFns } from "./ventanaAgregarRespuestaColumnaB.vue?vue&type=template&id=bae45322&scoped=true&"
import script from "./ventanaAgregarRespuestaColumnaB.vue?vue&type=script&lang=js&"
export * from "./ventanaAgregarRespuestaColumnaB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae45322",
  null
  
)

export default component.exports